import { EventV2 } from '@front-app/services/EventsApi/EventModel';
import { Group } from '@front-app/services/GroupsApi/GroupModel';
import { UserRole } from '@front-app/services/UserApi/UserModel';
import { isAdminRole, isInviteeRole, isMemberRole } from '@front-app/util/permission';
import { computed, ComputedRef, Ref } from '@vue/composition-api';

export interface UseGroupMembershipRole {
	isMember: boolean;
	isAdmin: boolean;
	isInvitee: boolean;
}

export interface UseEventMembershipRole {
	isRegistered: boolean;
	isAdmin: boolean;
	isInvitee: boolean;
}

export const useGroupRole = (group: Ref<Group>): ComputedRef<UseGroupMembershipRole> => computed(() => useGroupMembershipRole(group.value.role));

export const useEventRole = (event: Ref<EventV2>): ComputedRef<UseGroupMembershipRole> => computed(() => useGroupMembershipRole(event.value.membershipRole));

export function useGroupMembershipRole(role: UserRole): UseGroupMembershipRole {
	return {
		isMember: isMemberRole(role),
		isAdmin: isAdminRole(role),
		isInvitee: isInviteeRole(role),
	};
}

/**
 * @deprecated in favor of useEventRole above
 */
export function useEventMembershipRole(role: UserRole): UseEventMembershipRole {
	return {
		isRegistered: isMemberRole(role),
		isAdmin: isAdminRole(role),
		isInvitee: isInviteeRole(role),
	};
}
